import { appInsights } from './src/AppInsights';

export { wrapRootElement } from './src/root-wrapper';

export const onRouteUpdate = () => {
  if (appInsights) {
    appInsights.trackPageView();
  }
};
